import React, { useState, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./ProductTabs.css";
// Plating & Specialty Chemicals Products
import electrolessNickelImg from "../assets/SubProducts/Plating-Specialty-Chemicals/ELECTROLESS-NICKEL.png";
import zincFlakeImg from "../assets/SubProducts/Plating-Specialty-Chemicals/ZINC-FLAKE-COATINGS.png";
import tinImg from "../assets/SubProducts/Plating-Specialty-Chemicals/TIN-PLATING.png";
import zincAlloyImg from "../assets/SubProducts/Plating-Specialty-Chemicals/ZINC-ALLOY-PLATING.png";
import nickelImg from "../assets/SubProducts/Plating-Specialty-Chemicals/NICKEL-PLATING.png";
import copperproductsImg from "../assets/SubProducts/Plating-Specialty-Chemicals/COPPER PLATING.png";
import platingPlasticImg from "../assets/SubProducts/Plating-Specialty-Chemicals/PLATING-ON-PLASTIC.png";
import hardChromeImg from "../assets/SubProducts/Plating-Specialty-Chemicals/HARD-CHROME-PLATING.png";
import paintSupportImg from "../assets/SubProducts/Plating-Specialty-Chemicals/paint-support-technology.png";
import corrosionResistanceImg from "../assets/SubProducts/Plating-Specialty-Chemicals/CORROSION-RESISTANCE-COATINGS.png";
import functionalElectroImg from "../assets/SubProducts/Plating-Specialty-Chemicals/FUNCTIONAL-ELECTRO-COATINGS.png";
import degreasingImg from "../assets/SubProducts/Plating-Specialty-Chemicals/DEGREASING-CHEMICALS.png";

// Basic & Lab Chemicals Products
import chromicAcidImg from "../assets/SubProducts/Basic-Lab-Chemicals/CHROMIC ACID FLAKES & LIQUID.png";
import nickelSulphateImg from "../assets/SubProducts/Basic-Lab-Chemicals/NICKEL SULPHATE.png";
import nickelSuphamateImg from "../assets/SubProducts/Basic-Lab-Chemicals/NICKEL SUPHAMATE.png";
import nickelChlorideImg from "../assets/SubProducts/Basic-Lab-Chemicals/NICKEL CHLORIDE.png";
import boricAcidImg from "../assets/SubProducts/Basic-Lab-Chemicals/NICKEL CHLORIDE (1).png";
import causticSodaImg from "../assets/SubProducts/Basic-Lab-Chemicals/CAUSTIC SODA.png";
import nickelCarbonateImg from "../assets/SubProducts/Basic-Lab-Chemicals/NICKEL CARBONATE.png";
import labChemicalsImg from "../assets/SubProducts/Basic-Lab-Chemicals/OTHER BASIC LAB CHEMICALS.png";

// Metals Products
import nickelImg1 from "../assets/SubProducts/Metals/NICKEL.png";
import zincImg1 from "../assets/SubProducts/Metals/ZINC.png";
import oxygenCopperImg1 from "../assets/SubProducts/Metals/OXYGEN-FREE-COPPER.png";
import phosphorCopperImg1 from "../assets/SubProducts/Metals/PHOSPHORISED-PURE-COPPER.png";
import tinImg1 from "../assets/SubProducts/Metals/TIN.png";
import leadImg1 from "../assets/SubProducts/Metals/LEAD.png";

// Abrasives Products
import bondedImg from "../assets/SubProducts/Abrasives/Bonded.png";
import coatedImg from "../assets/SubProducts/Abrasives/Coated.png";
import nonwovenImg from "../assets/SubProducts/Abrasives/Nonwoven.png";
import superabrasiveImg from "../assets/SubProducts/Abrasives/Superabrasive.png";
import thinwheelsImg from "../assets/SubProducts/Abrasives/Thinwheels.png";
import constructionImg from "../assets/SubProducts/Abrasives/Thinwheels.png"; // same as Thinwheels

// Cutting Tools Products
import millingImg1 from "../assets/SubProducts/cutting-tools/Milling Cutters & Solid End Mills.png";
import turningInsertsImg1 from "../assets/SubProducts/cutting-tools/ISO Turning Inserts, Grooving & CBN inserts.png";
import carbideDrillsImg1 from "../assets/SubProducts/cutting-tools/NON-WOVEN ABRASIVES.png";
import turningMillingTappingImg1 from "../assets/SubProducts/cutting-tools/Turning, Milling & Tapping.png";
import toolingSystemsImg1 from "../assets/SubProducts/cutting-tools/Rotating Holders, Stationary Adapters & Shrink fit Devices.png";


import alkydPolyurethaneImg from "../assets/SubProducts/Wood-Glass-Coatings/ALKYD-POLYURETHANE-COATINGS.png";
import acrylicPolyurethaneImg from "../assets/SubProducts/Wood-Glass-Coatings/ACRYLIC-POLYURETHANE-COATINGS.png";
import uvCoatingsImg from "../assets/SubProducts/Wood-Glass-Coatings/UV-COATINGS.png";
import waterBorneImg from "../assets/SubProducts/Wood-Glass-Coatings/WATER-BORNE-EXTERIOR-INTERIOR.png";
import puGlassImg from "../assets/SubProducts/Wood-Glass-Coatings/PU-GLASS-COATINGS.png";
import epoxyAcrylicImg from "../assets/SubProducts/Wood-Glass-Coatings/EPOXY-ACRYLIC-ISOLATORS.png";
import melamineImg from "../assets/SubProducts/Wood-Glass-Coatings/MELAMINE.png";
import specialEffectsImg from "../assets/SubProducts/Wood-Glass-Coatings/SPECIAL-EFFECTS.png";
import glazersDyesImg from "../assets/SubProducts/Wood-Glass-Coatings/GLAZERS-DYES.png";
import stainsImg from "../assets/SubProducts/Wood-Glass-Coatings/SOLVENT-WATER-UNIVERSAL-STAINS.png";
import fireRetardantImg from "../assets/SubProducts/Wood-Glass-Coatings/FIRE-RETARDANT-COATINGS.png";
import pigmentedImg from "../assets/SubProducts/Wood-Glass-Coatings/PIGMENTED-COATINGS.png";

import epoxyImg from "../assets/SubProducts/metal-coatings/EPOXY-COATINGS.png";
import polyurethaneImg from "../assets/SubProducts/metal-coatings/ACRYLIC-POLYURETHANE-COATINGS.png";
import antibacterialImg from "../assets/SubProducts/metal-coatings/antibacterial.png";
import softFeelImg from "../assets/SubProducts/metal-coatings/SOFT-FEEL-LACQUER-METAL-COATINGS.png";
import monoCoatImg from "../assets/SubProducts/metal-coatings/MONO-COAT-DTM.png";
import electrophoreticImg from "../assets/SubProducts/metal-coatings/ELECTROPHORETIC.png";
import tpaImg from "../assets/SubProducts/metal-coatings/ELECTROPHORETIC (1).png";
import tsaImg from "../assets/SubProducts/metal-coatings/THERMOSETTING-ACRYLIC-TSA.png";
import uvCurableImg from "../assets/SubProducts/metal-coatings/UV-CURABLE-METAL-COATINGS.png";


import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";

import { Pagination, Autoplay } from "swiper/modules";

const tabs = [
  { id: "specialty", label: "PLATING AND SPECIALITY CHEMICALS " },
  { id: "basic", label: "BASIC AND LAB CHEMICALS" },
  { id: "metals", label: "METALS" },
  { id: "abrasives", label: "ABRASIVES" },
  { id: "cutting", label: "CUTTING TOOLS" },
  { id: "woodGlass", label: "WOOD & GLASS COATINGS" },
  { id: "metalscoatings", label: "METAL COATINGS" },
];

const contentData = {
  specialty: [
    { title: "ELECTROLESS NICKEL", img: electrolessNickelImg },
    { title: "ZINC FLAKE COATINGS", img: zincFlakeImg },
    { title: "TIN PLATING", img: tinImg },
    { title: "ZINC ALLOY PLATING", img: zincAlloyImg },
    { title: "NICKEL PLATING", img: nickelImg },
    { title: "COPPER PLATING", img: copperproductsImg },
    { title: "PLATING ON PLASTIC", img: platingPlasticImg },
    { title: "HARD CHROME PLATING", img: hardChromeImg },
    { title: "PAINT SUPPORT TECHNOLOGY", img: paintSupportImg },
    { title: "CORROSION RESISTANCE COATINGS", img: corrosionResistanceImg },
    { title: "FUNCTIONAL ELECTRO COATINGS", img: functionalElectroImg },
    { title: "DEGREASING CHEMICALS", img: degreasingImg },
  ],

  basic: [
    { title: "CHROMIC ACID FLAKES & LIQUID", img: chromicAcidImg },
    { title: "NICKEL SULPHATE", img: nickelSulphateImg },
    { title: "NICKEL SUPHAMATE", img: nickelSuphamateImg },
    { title: "NICKEL CHLORIDE", img: nickelChlorideImg },
    { title: "BORIC ACID", img: boricAcidImg },
    { title: "CAUSTIC SODA", img: causticSodaImg },
    { title: "NICKEL CARBONATE", img: nickelCarbonateImg },
    { title: "OTHER BASIC LAB CHEMICALS", img: labChemicalsImg },
  ],

  metals: [
    { title: "NICKEL OF ALL DIMENSIONS", img: nickelImg1 },
    { title: "ZINC", img: zincImg1 },
    { title: "OXYGEN FREE COPPER", img: oxygenCopperImg1 },
    { title: "PHOSPHARISED PURE COPPER", img: phosphorCopperImg1 },
    { title: "TIN", img: tinImg1 },
    { title: "LEAD", img: leadImg1 },
  ],

  abrasives: [
    { title: "BONDED ABRASIVES", img: bondedImg },
    { title: "COATED ABRASIVES", img: coatedImg },
    { title: "NON-WOVEN ABRASIVES", img: nonwovenImg },
    { title: "SUPERABRASIVES", img: superabrasiveImg },
    { title: "THIN WHEELS", img: thinwheelsImg },
    { title: "CONSTRUCTION PRODUCTS", img: constructionImg },
  ],

  cutting: [
    { title: "Milling Cutters & Solid End Mills", img: millingImg1 },
    { title: "ISO Turning Inserts, Grooving & CBN Inserts", img: turningInsertsImg1 },
    { title: "Carbide Drills, Boring Heads & Reamers", img: carbideDrillsImg1 },
    { title: "Turning, Milling & Tapping", img: turningMillingTappingImg1 },
    { title: "Rotating Holders, Stationary Adapters & Shrink Fit Devices", img: toolingSystemsImg1 },
  ],

  woodGlass: [
    { title: "ALKYD POLYURETHANE COATINGS", img: alkydPolyurethaneImg },
    { title: "ACRYLIC POLYURETHANE COATINGS", img: acrylicPolyurethaneImg },
    { title: "UV COATINGS", img: uvCoatingsImg },
    { title: "WATER BORNE EXTERIOR & INTERIOR COATINGS", img: waterBorneImg },
    { title: "PU GLASS COATINGS", img: puGlassImg },
    { title: "EPOXY & ACRYLIC ISOLATORS", img: epoxyAcrylicImg },
    { title: "MELAMINE", img: melamineImg },
    { title: "SPECIAL EFFECTS – METALLIC, CRACKLE, PATINA, PEARL & TEXTURE", img: specialEffectsImg },
    { title: "GLAZERS & DYES", img: glazersDyesImg },
    { title: "SOLVENT, WATER BASE & UNIVERSAL STAINS", img: stainsImg },
    { title: "FIRE RETARDANT COATINGS", img: fireRetardantImg },
    { title: "PIGMENTED COATINGS", img: pigmentedImg },
  ],

  metalscoatings: [
  { title: "EPOXY COATINGS", img: epoxyImg },
  { title: "POLYURETHANE COATINGS", img: polyurethaneImg },
  { title: "ANTI BACTERIAL COATINGS", img: antibacterialImg },
  { title: "SOFT FEEL LACQUER", img: softFeelImg },
  { title: "MONO COAT DTM", img: monoCoatImg },
  { title: "ELECTRO PHORETIC", img: electrophoreticImg },
  { title: "THERMOPLASTIC ACRYLIC - TPA", img: tpaImg },
  { title: "THERMOSETTING ACRYLIC - TSA", img: tsaImg },
  { title: "UV CURABLE", img: uvCurableImg },
],

};


const ProductTabs = () => {
  const [activeTab, setActiveTab] = useState("specialty");
  const sliderRef = useRef(null); // ✅ Swiper reference

  return (
    <div className="product-tabs">
<style>
  {`
    /* Base dot */
    .swiper-pagination-bullet {
      width: 6px;
      height: 6px;
      background: #ccc;
      opacity: 1;
      border-radius: 50%;
      position: relative;
    }

    /* Active dot */
    .swiper-pagination-bullet-active {
      background: #CA7511 !important;
    }

    /* Outer ring */
    .swiper-pagination-bullet-active::after {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 14px;   /* outer ring size */
      height: 14px;
      border: 1px solid #CA7511;
      border-radius: 50%;
    }
  `}
</style>



      {/* Header Section */}
      <div className="product-header">
        <motion.div
          initial={{ opacity: 0, y: -60 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ amount: 0.3 }}
        >
          <span className="about-label">Our Products</span>
          <h2>
            SE is a Leading Distribution <br /> House in The 
            <span> South India Region</span>
          </h2>
        </motion.div>

        <motion.div
          className="product-header-text"
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
          viewport={{ amount: 0.3 }}
        >
          <p>
            We’ve sourced raw materials from suppliers around the world and marketed them to manufacturers serving key industrial and consumer marketplaces. These relationships are based on a long-standing expertise, exceptional follow-through and the fastest turnaround times in the business.
          </p>
        </motion.div>
      </div>

      {/* Tab Navigation */}
      <div className="tab-nav">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`tab-btn ${activeTab === tab.id ? "active" : ""}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Title + Button + Controls */}
      <div className="tab-title-row">
        <h2 className="tab-section-title">
          {tabs.find((t) => t.id === activeTab)?.label}
        </h2>
        <div className="tab-actions">
          <button
  className="explore-btn"
  onClick={() => (window.location.href = "/products")}
>
  Explore Now
</button>

          <div className="tab-controls">
            {/* ✅ Custom arrows controlling Swiper */}
            <button onClick={() => sliderRef.current?.swiper.slidePrev()}>
              ‹
            </button>
            <button onClick={() => sliderRef.current?.swiper.slideNext()}>
              ›
            </button>
          </div>
        </div>
      </div>

      {/* Tab Content with Slider */}
      <div className="tab-content">
        <AnimatePresence mode="wait">
          <motion.div
            key={activeTab}
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -40 }}
            transition={{ duration: 0.4 }}
          >
            <Swiper
              ref={sliderRef} // ✅ attach ref here
              modules={[Pagination, Autoplay]}
              pagination={{ clickable: true }}
              autoplay={{ delay: 4000 }}
              loop
              spaceBetween={20}
              breakpoints={{
                0: { slidesPerView: 1, centeredSlides: true, spaceBetween: 10 },
                768: { slidesPerView: 2, spaceBetween: 15 },
                1024: { slidesPerView: 3, spaceBetween: 20 },
              }}
            >
              {contentData[activeTab].map((item, idx) => (
                <SwiperSlide key={idx}>
                  <div className="tab-card">
                    <div className="img-style">
                      <img src={item.img} alt={item.title} />
                      <h4>{item.title}</h4>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
};

export default ProductTabs;
